module.exports = __webpack_public_path__ + "static/media/erro404.772b1349.gif";